import styled from "styled-components";
import { Modal } from "antd";

const StyledModal = styled(Modal)`
  &.ant-modal {
    border-radius: 12px;
    border-bottom: 1px solid #c9c8c8;
    background: #fff;
    box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);
    padding: unset;

    .ant-modal-content {
      padding: 32px;
    }

    .ant-modal-header {
      margin-bottom: 32px;

      .ant-modal-title {
        color: #1e1919;
        font-size: 18px;
        font-weight: 700;
      }
    }

    .ant-modal-footer {
      margin-top: 32px;
    }

    iframe {
      border-radius: 12px;
    }
  }
`;

export default StyledModal;
